import React, { useState, useEffect } from "react";
import { Button, Icon, Modal, Grid, Segment, Header, Image, Card, Label, Confirm } from "semantic-ui-react";
import { MapInteractionCSS } from "react-map-interaction";
import { b64toBlob } from "utils/file";
import ScansCenter from "components/Others/ScansCenter";
import { isJson } from "utils/json";

const AddDocsTvSecModal = ({
	open,
	close,
	folder,
	folderHelp,
	docs,
	getScansForTVsecretariat,
	addScanOrdoToPrescription,
	scans,
	removeScanOrdoFromList,
	loadingScans,
	prescriptions,
	refreshCenterScans,
}) => {
	const [searchInCenter, setSearchInCenter] = useState(false);
	const [openConfimMissingBC, setOpenConfirmMissingBC] = useState(false);
	const [barcodes, setBarcodes] = useState([]);
	const [loading, setLoading] = useState(loadingScans);
	const [barcodesFromNurse, setBarcodesFromNurse] = useState(
		folderHelp && isJson(folderHelp.barcodes) ? JSON.parse(folderHelp.barcodes).map((f) => f.bc) : []
	);

	const searchBarcodes = () => {
		return docs.length > 0
			? docs
					.map((d) => d.barcode)
					.reduce((arr, item) => {
						if (!arr.includes(item)) arr.push(item);
						return arr;
					}, barcodesFromNurse)
			: barcodesFromNurse;
	};
	useEffect(() => {
		setBarcodes(barcodesFromNurse ? searchBarcodes() : []);
		if (loadingScans && !loading) setLoading(true);
	}, [loadingScans]);

	useEffect(() => {
		setBarcodes(barcodesFromNurse ? searchBarcodes() : []);
	}, [folderHelp]);

	useEffect(() => {
		setBarcodes(barcodesFromNurse ? searchBarcodes() : []);
		const interval = setInterval(async () => {
			if (getScansForTVsecretariat && (searchInCenter || barcodes.length > 0)) {
				await getScansForTVsecretariat(searchInCenter, barcodes, false, folder ? folder.center.id : null);
			}
		}, 15000);
		return () => clearInterval(interval);
	}, [searchInCenter, folderHelp]);

	const refresh = (clean = false) => {
		getScansForTVsecretariat(searchInCenter, barcodes, clean, folder.center.id);
	};

	const closeAll = () => {
		setSearchInCenter(false);
		setBarcodes([]);
		refresh(true);
		close();
	};
	const isScanFound = (bc) => {
		if (!docs) return false;
		const docIndex = docs.findIndex((d) => d.barcode && d.barcode.includes(bc));
		return docIndex > -1 && !docs[docIndex].isDefaultScan;
	};
	
	const getDocByBarcode = (bc) => {
		if (!docs) return null;
		const docIndex = docs.findIndex((d) => d.barcode && d.barcode.includes(bc));
		return docIndex > -1 ? docs[docIndex] : null;
	};
	const displayDoc = (d) => {
		return (
			<>
				{d.type !== "application/pdf" && (
					<div style={{ width: "auto", maxWidth: "320px", padding: "2px 20px 2px 2px", maxHeight: "320px", overflowY: "auto" }}>
						<div style={{ display: "flex", width: "100%", flexDirection: "column" }}>
							<MapInteractionCSS minScale={1} maxScale={3}>
								<Image
									src={`data:${d.type};charset=utf-8;base64,${d.base64}`}
									onContextMenu={(e) => e.preventDefault()}
									style={{ overflowY: "inherit" }}
								/>
							</MapInteractionCSS>
							{d.base64_back && (
								<MapInteractionCSS minScale={1} maxScale={3}>
									<Image
										src={`data:${d.type};charset=utf-8;base64,${d.base64_back}`}
										onContextMenu={(e) => e.preventDefault()}
										style={{ width: "auto", height: "50vh" }}
									/>
								</MapInteractionCSS>
							)}
						</div>
					</div>
				)}
				{d.type === "application/pdf" && (
					<div style={{ width: "auto", maxWidth: "520px", padding: "2px 20px 2px 2px", maxHeight: "520px", overflowY: "scroll" }}>
						<iframe
							id={`fra-${d.id}`}
							//Prevent download
							src={URL.createObjectURL(b64toBlob(d.base64, "application/pdf")) + "#toolbar=0"}
							// src={`data:${files[fileIndex].type};base64,${files[fileIndex].base64}`}
							title={"Ordonnance"}
							name={d.filename}
							style={{ width: "100%", height: "50vh" }}
						></iframe>
					</div>
				)}
			</>
		);
	};

	return (
		<Modal size="large" open={open} closeOnEscape closeOnDimmerClick onClose={closeAll}>
			<Modal.Header>Recherche de documents scannés en centre ({folder.center.name})</Modal.Header>

			<Modal.Content>
				<Grid centered style={{ padding: "10px" }}>
					<Grid.Row>
						<Grid.Column>
							{((docs && docs.length > 0) || barcodes) && (
								<Card.Group centered>
									{barcodes.map((bc, documentIndex) => {
										const doc = getDocByBarcode(bc);
										const docIndex = docs ? docs.findIndex((d) => d.barcode && d.barcode.includes(bc)) : -1;
										const found = isScanFound(bc);
										
										return (
											<Card
												key={bc}
												image={doc ? displayDoc(doc) : ""}
												color={found ? "green" : "red"}
												header={
													found && doc && doc.document_type && doc.document_type.title
														? `${doc.document_type.title} - n° ${docIndex + 1}`
														: found && doc
														? `Document - n° ${docIndex + 1}`
														: "Scan non trouvé"
												}
											description={
												found && doc ? (
													doc.base64_back ? (
														<>
															<Icon name="file alternate" /> Recto-verso
														</>
													) : (
														<>
															<Icon name="sticky note outline" /> Recto
														</>
													)
												) : (
													""
												)
											}
											meta={
												<Label color={!isScanFound(bc) ? "red" : "green"}>
													<Icon name="barcode" />
													{bc}
												</Label>
											}
											extra={
												!isScanFound(bc) ? (
													<Button
														onClick={() => {
															setSearchInCenter(false);
															getScansForTVsecretariat(false, barcodes, false, folder.center.id);
														}}
													>
														{loadingScans ? <Icon name="circle notched" loading /> : <Icon name="search" />}Rechercher{" "}
													</Button>
												) : (
													""
												)
											}
										/>
									);
									})}
								</Card.Group>
							)}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row style={{ width: "100%" }}>
						<Segment placeholder style={{ width: "100%", margin: "12px" }}>
							<Button
								onClick={() => {
									setSearchInCenter(true);
									getScansForTVsecretariat(true, null, false, folder.center.id);
								}}
							>
								{" "}
								{loadingScans ? <Icon name="circle notched" loading /> : <Icon name="search plus" />}Plus de documents du centre
							</Button>
							{scans.length === 0 && loading && (searchInCenter || barcodes.length > 0) && (
								<Segment placeholder style={{ width: "100%" }}>
									<Header icon style={{ paddingTop: "10px" }}>
										<Icon name="pdf file outline" /> Aucun document disponible.
									</Header>
								</Segment>
							)}
							{scans.length > 0 && (
								<ScansCenter
									center={folder.center}
									scans={scans}
									removeScanOrdo={removeScanOrdoFromList}
									getScansForTVsecretariat={getScansForTVsecretariat}
									refreshCenterScans={refreshCenterScans}
									addScanOrdoToPrescription={addScanOrdoToPrescription}
									prescriptions={prescriptions}
									barcodes={barcodes}
								/>
							)}
						</Segment>
					</Grid.Row>
				</Grid>
			</Modal.Content>

			<Modal.Actions>
				<Button
					onClick={(e) => {
						if (e !== undefined) e.preventDefault();
						let next = true;
						for (const bc of barcodes) {
							if (
								!docs
									.filter((d) => d.barcode)
									.flatMap((d) => d.barcode.split("-"))
									.includes(bc)
							)
								next = false;
						}
						if (!next) {
							setOpenConfirmMissingBC(true);
						} else close();
					}}
				>
					Fermer
				</Button>
			</Modal.Actions>

			<Confirm
				open={openConfimMissingBC}
				content={"Les code-barres recherchés n'ont pas tous été trouvés, voulez-vous continuer ? "}
				cancelButton="Annuler"
				confirmButton="Continuer"
				onCancel={(e) => {
					if (e !== undefined) e.preventDefault();
					setOpenConfirmMissingBC(false);
				}}
				onConfirm={(e) => {
					if (e !== undefined) e.preventDefault();
					setOpenConfirmMissingBC(false);
					close();
				}}
			/>
		</Modal>
	);
};

export default AddDocsTvSecModal;
